import { ComponentProps, PropsWithChildren } from 'react';
import { FormattedMessage } from 'react-intl';

import FormAccordion from '@components/accordions/FormAccordion';
import BodyCopyBold from '@components/typography/BodyCopyBold';

type Props = PropsWithChildren<{
  color: ComponentProps<typeof FormAccordion>['color'];
  sectionName: string;
}>;

const CareProfileSection = ({ children, color, sectionName }: Props) => (
  <FormAccordion
    color={color}
    content={children}
    heading={
      <BodyCopyBold>
        <FormattedMessage id={`pages.careProfile.sectionTitles.${sectionName}`} />
      </BodyCopyBold>
    }
  />
);

export default CareProfileSection;
